import loomLead from './loom_lead';
import workflow from './workflow';

export default {
  ...loomLead,
  workflow,
};
